"use strict";

function getYoutubePoster(url: string): string {
    let ID: string = "";
    const splitUrl = url.replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/|youtube-nocookie\.com\/)/);
    if (splitUrl[2] !== undefined) {
        const splitId = splitUrl[2].split(/[^0-9a-z_\-]/i);
        ID = splitId[0];
    } else {
        ID = url;
    }
    return `https://img.youtube.com/vi/${ID}/sddefault.jpg`;
}

export function isYoutubeVideo(url: string): boolean {
    return !!(url.match(/(http:|https:)?(\/\/)?(www\.)?(youtube(?:-nocookie)?\.com|youtu\.be)\/(watch|embed)?(\?v=|\/)?(\S+)?/));
}

export async function loadYouTubeAPI(): Promise<void> {
    if (window.YT) return;
    return new Promise((resolve) => {
        if (window.YT && window.YT.Player) return resolve();
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        window.onYouTubeIframeAPIReady = () => resolve();
        document.head.appendChild(tag);
    });
}

export function initYTPlayer(iframe: HTMLIFrameElement, events: any): void {
    new window.YT.Player(iframe, { events });
}

export default function initYouTubeFeatures(): void {
    document.querySelectorAll("[data-poster-id]").forEach(element => {
        const URL = element.getAttribute("data-poster-id") ?? "";
        element.setAttribute("src", getYoutubePoster(URL));
    });

    document.querySelectorAll("a").forEach(element => {
        if (!isYoutubeVideo(element.href)) return;
        element.setAttribute("data-bs-toggle", "video");
    });

    document.querySelectorAll("[data-bs-toggle=\"popover\"]").forEach(element => {
        window.bootstrap.Popover.getOrCreateInstance(element, {
            trigger: "focus",
            placement: "bottom"
        });
    });
}
